import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCodeTextarea',
  props: {
    value: {}
  },
  setup(__props: any) {



const textarea = ref<HTMLTextAreaElement>();

const select = () => {
	textarea.value?.select();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    ref_key: "textarea",
    ref: textarea,
    value: _ctx.value,
    cols: "50",
    rows: "20",
    readonly: "",
    onClick: select
  }, null, 8, _hoisted_1))
}
}

})